import { call, takeLatest } from "redux-saga/effects";
import * as translationApis from "../apis/translationApis"
import { COMPLETE_REVIEW, DOCUMENTS_DROP_DOWN, GET_DRAFTED_DETAILS, GET_SIGNED_URL, GLOSSARY_DROP_DOWN, HTML_TEXT_BLOCKS, LIST_POST_EDITING, PDF_TEXT_BLOCKS, POST_EDIT_WORD, PPTX_TEXT_BLOCKS, PUBLISH_DOC, SEND_POST_EDITING, SEND_TO_MODEL, TRANSLATE_DOCUMENT, TRANSLATE_FILE, TRANSLATE_HTML_FILE, TRANSLATE_MORE_PAGES, TRANSLATION_JOBS, TRANSLATiON_JOBS, TRANSLATION_JOBS_VIEW, UPDATE_HTML_DOCUMENT, UPDATE_PDF_DOCUMENT, UPDATE_POST_EDIT_JOB, UPDATE_PPTX_DOCUMENT, UPDATE_WORD_DOCUMENT, VIEW_DOCUMENT, WORD_TEXT_BLOCKS } from "../actions/types";

export function* glossaryDropDownWorker(action) {
    try {
        const res = yield call(translationApis.glossaryDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* documentsDropDownWorker(action) {
    try {
        const res = yield call(translationApis.documentsDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* getSignedUrlWorker(action) {
    try {
        const res = yield call(translationApis.getSignedUrlApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateDocWorker(action) {
    try {
        const res = yield call(translationApis.translateDocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateMorePagesWorker(action) {
    try {
        const res = yield call(translationApis.translateDocMorePagesApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateHtmlFileWorker(action) {
    try {
        const res = yield call(translationApis.translateHtmlFileApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewDocWorker(action) {
    try {
        const res = yield call(translationApis.viewDocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translationJobListWorker(action) {
    try {
        const res = yield call(translationApis.recentTranslationsListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewTranslationJobWorker(action) {
    try {
        const res = yield call(translationApis.viewTranslationJobApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* publishDocWorker(action) {
    try {
        const res = yield call(translationApis.publishDocApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* sendPostEditingWorker(action) {
    try {
        const res = yield call(translationApis.sendPostEditingApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listPostEditingWorker(action) {
    try {
        const res = yield call(translationApis.listPostEditingApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* postEditWordWorker(action) {
    try {
        const res = yield call(translationApis.postEditWordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* completeReviewWorker(action) {
    try {
        const res = yield call(translationApis.completeReviewApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* getWordTextBlocksWorker(action) {
    try {
        const res = yield call(translationApis.getWordTextBlocksApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* getPptxTextBlocksWorker(action) {
    try {
        const res = yield call(translationApis.getPptxTextBlocksApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* getPdfTextBlocksWorker(action) {
    try {
        const res = yield call(translationApis.getPdfTextBlocksApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* getHtmlTextBlocksWorker(action) {
    try {
        const res = yield call(translationApis.getHtmlTextBlocksApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* updateWordFileWorker(action) {
    try {
        const res = yield call(translationApis.updateWordFileApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* updatePptxFileWorker(action) {
    try {
        const res = yield call(translationApis.updatePptxFileApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* updatePdfFileWorker(action) {
    try {
        const res = yield call(translationApis.updatePdfFileApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* updateHtmlFileWorker(action) {
    try {
        const res = yield call(translationApis.updateHtmlFileApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* sendToModelWorker(action) {
    try {
        const res = yield call(translationApis.sendToModelApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* draftedDetailsWorker(action) {
    try {
        const res = yield call(translationApis.draftedDetailsApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* updatePostEditJobWorker(action) {
    try {
        const res = yield call(translationApis.updatePostEditJobApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* translateFileWorker(action) {
    try {
        const res = yield call(translationApis.translateFileApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


/**Watcher functions */

export function* glossaryDropDownWatcher() {
    yield takeLatest(GLOSSARY_DROP_DOWN, glossaryDropDownWorker);
}

export function* documentsDropDownWatcher() {
    yield takeLatest(DOCUMENTS_DROP_DOWN, documentsDropDownWorker);
}

export function* getSignedUrlWatcher() {
    yield takeLatest(GET_SIGNED_URL, getSignedUrlWorker);
}

export function* translateDocWatcher() {
    yield takeLatest(TRANSLATE_DOCUMENT, translateDocWorker);
}

export function* translateMorePagesWatcher() {
    yield takeLatest(TRANSLATE_MORE_PAGES, translateMorePagesWorker);
}

export function* translateHtmlFIleWatcher() {
    yield takeLatest(TRANSLATE_HTML_FILE, translateHtmlFileWorker);
}

export function* viewDocWatcher() {
    yield takeLatest(VIEW_DOCUMENT, viewDocWorker);
}

export function* translationJobListWatcher() {
    yield takeLatest(TRANSLATION_JOBS, translationJobListWorker);
}

export function* viewTranslationJobWatcher() {
    yield takeLatest(TRANSLATION_JOBS_VIEW, viewTranslationJobWorker);
}

export function* publishDocWatcher() {
    yield takeLatest(PUBLISH_DOC, publishDocWorker);
}

export function* sendPostEditingWatcher() {
    yield takeLatest(SEND_POST_EDITING, sendPostEditingWorker);
}

export function* listPostEditingWatcher() {
    yield takeLatest(LIST_POST_EDITING, listPostEditingWorker);
}

export function* postEditWordWatcher() {
    yield takeLatest(POST_EDIT_WORD, postEditWordWorker);
}

export function* completeReviewWatcher() {
    yield takeLatest(COMPLETE_REVIEW, completeReviewWorker);
}

export function* getWordTextBlocksWatcher() {
    yield takeLatest(WORD_TEXT_BLOCKS, getWordTextBlocksWorker);
}


export function* getPptxTextBlocksWatcher() {
    yield takeLatest(PPTX_TEXT_BLOCKS, getPptxTextBlocksWorker);
}

export function* getPdfTextBlocksWatcher() {
    yield takeLatest(PDF_TEXT_BLOCKS, getPdfTextBlocksWorker);
}

export function* getHtmlTextBlocksWatcher() {
    yield takeLatest(HTML_TEXT_BLOCKS, getHtmlTextBlocksWorker);
}

export function* updateWordFileWatcher() {
    yield takeLatest(UPDATE_WORD_DOCUMENT, updateWordFileWorker);
}

export function* updatePptxFileWatcher() {
    yield takeLatest(UPDATE_PPTX_DOCUMENT, updatePptxFileWorker);
}

export function* updatePdfFileWatcher() {
    yield takeLatest(UPDATE_PDF_DOCUMENT, updatePdfFileWorker);
}

export function* updateHtmlFileWatcher() {
    yield takeLatest(UPDATE_HTML_DOCUMENT, updateHtmlFileWorker);
}

export function* sendToModelWatcher() {
    yield takeLatest(SEND_TO_MODEL, sendToModelWorker);
}

export function* draftedDetailsWatcher() {
    yield takeLatest(GET_DRAFTED_DETAILS, draftedDetailsWorker);
}

export function* updatePostEditJobWatcher() {
    yield takeLatest(UPDATE_POST_EDIT_JOB, updatePostEditJobWorker);
}

export function* translateFileWatcher() {
    yield takeLatest(TRANSLATE_FILE, translateFileWorker);
}